import { render, staticRenderFns } from "./ContactCreatePage.vue?vue&type=template&id=1854160d&"
import script from "./ContactCreatePage.vue?vue&type=script&lang=ts&"
export * from "./ContactCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1854160d')) {
      api.createRecord('1854160d', component.options)
    } else {
      api.reload('1854160d', component.options)
    }
    module.hot.accept("./ContactCreatePage.vue?vue&type=template&id=1854160d&", function () {
      api.rerender('1854160d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact-data/ContactCreatePage.vue"
export default component.exports